import { createAsyncThunk } from "@reduxjs/toolkit";
import { mapPlanCheckTrackers } from "../Types/PlanCheck/PlanCheckTrackerType";
import { getPlanCheckTrackerByFolderId } from "../../Api/PlanCheck/PlanCheckApiServices";

// get all spending project list
export const getAllPlanChckTrackerList = createAsyncThunk('getAllPlanChckTrackerList', async (folder_id:number, { rejectWithValue }) => {
  try {
    // api
    const response = await getPlanCheckTrackerByFolderId(folder_id);
    if (response.status) {
      return mapPlanCheckTrackers(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});
